import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, getIdpTicketByCustomString } from '@rsmu/auth';
import { of, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-auth',
    template: '',
    standalone: true
})
export class AuthComponent implements OnInit {
  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {

  }
  ngOnInit(): void {
    const url = this.router.url;
    const idpTicketParam = environment.idpTicketParam;
    let state: string;
    let idpTicket: string;

    this.route.queryParams
    .pipe(
      switchMap(params => {
        if(idpTicketParam) {
          idpTicket = getIdpTicketByCustomString(url, idpTicketParam) || params[idpTicketParam];
        }
        state = params['state'];
        return idpTicket ? this.auth.login$({idpTicket}) : of(null);
      }))
      .subscribe(() => {
        this.router.navigate([state || '/']);
      }
    );
  }
}